var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1921.757,
    height: 1177.694,
    viewBox: "0 0 1921.757 1177.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 1.241,
    x2: 0.209,
    y2: -0.214,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14204a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A202C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M2317.938-103.258S2257.209-532.1,1807.843-303.695,397.09,465.332,397.09,465.332L397.664,807l1921.183-.571Z",
    transform: "translate(-398.09 8181)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    transform: "translate(1 -7857.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M2317.938-103.258S2257.209-532.1,1807.843-303.695,397.09,465.332,397.09,465.332L397.664,807l1921.183-.571Z",
    transform: "translate(-398.09 8228)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(0 47)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(265 126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 156.5,
    cy: 156.5,
    r: 156.5,
    transform: "translate(1377 7946)",
    fill: "#fff",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 156.5,
    cy: 156.5,
    r: 156.5,
    transform: "translate(1396 8123)",
    fill: "#fff",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 156.5,
    cy: 156.5,
    r: 156.5,
    transform: "translate(1564 8002)",
    fill: "#fff",
    opacity: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162",
    transform: "translate(-1422 705)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167-2",
    "data-name": "Ellipse 167",
    cx: 156.5,
    cy: 156.5,
    r: 156.5,
    transform: "translate(1377 7946)",
    fill: "#fff",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168-2",
    "data-name": "Ellipse 168",
    cx: 156.5,
    cy: 156.5,
    r: 156.5,
    transform: "translate(1396 8123)",
    fill: "#fff",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169-2",
    "data-name": "Ellipse 169",
    cx: 156.5,
    cy: 156.5,
    r: 156.5,
    transform: "translate(1564 8002)",
    fill: "#fff",
    opacity: 0.02
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterShape);
export default __webpack_public_path__ + "static/media/footer_shape.0098a03033e0d6f2fb13b807309f70f8.svg";
export { ForwardRef as ReactComponent };